import {
  ArrowDownOutlined, ArrowUpOutlined, CheckOutlined, SwapOutlined,
} from '@ant-design/icons';
import { Row, Space, Statistic } from 'antd';
import { useQuery } from 'react-query';
import { useEffect, useState } from 'react';
import CustomPageContainer from '../../../components/CustomPageContainer';
import Spinner from '../../../components/spinner/Spinner';
import styles from '../src/dashboard.module.less';
import { getDashboardData } from '../src/dashboardApis';
import StatisticsCard from './StatisticsCard';

const Dashboard = () => {
  const {
    data, isLoading,
  } = useQuery('getDashboardData', getDashboardData);

  const [dashboardData, setDashboardData] = useState({} as dashboard.DashboardData);

  useEffect(() => {
    if (data) {
      setDashboardData(data.data.data);
    }
  }, [data]);

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <CustomPageContainer breadcrumbName="" title="Dashboard">
      <Space direction="vertical" size="large" className={styles['full-width']}>
        <Row gutter={[4, 40]}>
          <StatisticsCard
            cardTitle="Investors"
            tagColor="blue"
            tag="All"
            primaryStatisticsValue={dashboardData.totalInvestor}
            primaryStatisticsQuantifier="Users"
          />
          <StatisticsCard
            cardTitle="Investors"
            tagColor="green"
            tag="Active & Email Verified"
            primaryStatisticsValue={dashboardData.totalActiveAndVerifiedInvestor}
            primaryStatisticsQuantifier="Users"
            percentageStatistics={(
              <Statistic
                value={dashboardData.percentageVerifiedInvestor}
                precision={2}
                valueStyle={{ color: '#1AB293', fontSize: 16 }}
                prefix={<ArrowUpOutlined />}
                suffix="%"
              />
            )}
          />
          <StatisticsCard
            cardTitle="Investors"
            tagColor="red"
            tag="Inactive & Email Unverified"
            primaryStatisticsValue={dashboardData.totalInactiveAndUnerifiedInvestor}
            primaryStatisticsQuantifier="Users"
            percentageStatistics={(
              <Statistic
                value={dashboardData.percentageInactiveAndUnerifiedInvestor}
                precision={2}
                valueStyle={{ color: '#ED5564', fontSize: 16 }}
                prefix={<ArrowDownOutlined />}
                suffix="%"
              />
            )}
          />
          <StatisticsCard
            cardTitle="User Interested"
            tagColor="geekblue"
            tag="All"
            primaryStatisticsValue={dashboardData.totalUserInterested}
            primaryStatisticsQuantifier="Users"
          />
          <StatisticsCard
            cardTitle="Portfolio"
            tagColor="blue"
            tag="All"
            primaryStatisticsValue={dashboardData.allTotalNotes}
            primaryStatisticsQuantifier="Notes"
            secondaryStatisticsValue={dashboardData.closeInvestAmount}
          />
          <StatisticsCard
            cardTitle="Portfolio"
            tagColor="orange"
            tag="Pending Funder Approval"
            primaryStatisticsValue={dashboardData.pendingFunderApprovalTotalNotes}
            primaryStatisticsQuantifier="Notes"
            secondaryStatisticsValue={dashboardData.pendingFunderApprovalInvestAmount}
            percentageStatistics={(
              <Statistic
                value={dashboardData.percentPFA}
                precision={2}
                valueStyle={{ color: 'orange', fontSize: 16, textAlign: 'end' }}
                prefix={<SwapOutlined />}
                suffix="%"
              />
            )}
          />
          <StatisticsCard
            cardTitle="Portfolio"
            tagColor="green"
            tag="Disbursed"
            primaryStatisticsValue={dashboardData.pendingDisbursedTotalNotes}
            primaryStatisticsQuantifier="Notes"
            secondaryStatisticsValue={dashboardData.pendingDisbursementInvestAmount}
            percentageStatistics={(
              <Statistic
                value={dashboardData.percentDisbursement}
                precision={2}
                valueStyle={{ color: '#1AB293', fontSize: 16, textAlign: 'end' }}
                prefix={<ArrowUpOutlined />}
                suffix="%"
              />
            )}
          />
          <StatisticsCard
            cardTitle="Portfolio"
            tag="Closed"
            primaryStatisticsValue={dashboardData.closeTotalNotes}
            primaryStatisticsQuantifier="Notes"
            secondaryStatisticsValue={dashboardData.closeInvestAmount}
            percentageStatistics={(
              <Statistic
                value={dashboardData.percentClosed}
                precision={2}
                valueStyle={{ fontSize: 16, textAlign: 'end' }}
                prefix={<CheckOutlined />}
                suffix="%"
              />
            )}
          />
        </Row>
      </Space>
    </CustomPageContainer>
  );
};

export default Dashboard;
